import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncActivityCenterModule as MncActivityCenterModule } from '@app/mnc-activitycenter.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('ACTIVITYCENTER UI Version:', {
  buildNumber,
  commit,
})

platformBrowserDynamic()
  .bootstrapModule(MncActivityCenterModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
